import {
  Box,
  Container,
  Divider,
  Table,
  TableBody,
  Typography,
} from "@mui/material";
import "./../../App.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  StyledCell,
  StyledRow,
} from "../../styled-components/styledTableComponents";
import CancelIcon from "@mui/icons-material/Cancel";
import InfoIcon from "@mui/icons-material/Info";
import HelpIcon from "@mui/icons-material/Help";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { tableCellClasses } from "@mui/material/TableCell";

export function CardDetails(cardSystemId: any) {
  const { t } = useTranslation();

  const historyCard = useSelector(
    (state: any) => state.card.cardWithHistory.history
  );
  const extendedCards = useSelector((state: any) => state.card.extendedCards);
  const card = useSelector((state: any) => state.card.cardWithHistory.current);
  const consent = useSelector((state: any) => state.person.cardConsent);
  const readConsentOptOut = useSelector((state: any) => state.person.cardConsent.readConsentOptOut);

  const findInArray = () => {
    if (card) {
      if (cardSystemId.cardSystemId === card.cardSystemId) {
        return card;
      }
    }
    if (historyCard.length > 0) {
      return historyCard.find(
        (e: any) => e.cardSystemId === cardSystemId.cardSystemId
      );
    }
    if (extendedCards) {
      return extendedCards.find(
        (e: any) => e.cardSystemId === cardSystemId.cardSystemId
      );
    }
  };

  const currentCard = findInArray();

  return (
    <Box maxWidth="30em">
      <Container
        disableGutters
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
        }}
      >
        {getStatusImg(currentCard.status)}
        <Typography variant="h4" component="div">
          {t("searchCard.cardInfo.status." + currentCard.status)}
        </Typography>
      </Container>

      <Table
        className="firstColumnBold"
        sx={{
          [`& .${tableCellClasses.root}`]: {
            borderBottom: "none",
          },
        }}
      >
        <TableBody>
          {currentCard.persons.map((person: any, i: any) => (
            <StyledRow key={i}>
              {currentCard.persons.length > 1 ? (
                <StyledCell>
                  {t("searchCard.cardInfo.personId") + " " + (i + 1)}
                </StyledCell>
              ) : (
                <StyledCell>{t("searchCard.cardInfo.personId")}</StyledCell>
              )}
              <StyledCell>{person.id}</StyledCell>
              {i === 0 && (
                <StyledCell>
                  {(() => {
                    let consentText;
                    if (readConsentOptOut) {
                      consentText = (
                        <Typography
                          sx={{ color: "red", marginLeft: "0.5rem" }}
                          variant="body2"
                        >
                          Samtycke nekat
                        </Typography>
                      );
                    } else if (consent.readConsent) {
                      consentText = (
                        <Typography
                          sx={{ color: "green", marginLeft: "0.5rem" }}
                          variant="body2"
                        >
                          Samtycke finns
                        </Typography>
                      );
                    } else {
                      consentText = (
                        <Typography
                          sx={{ color: "gray", marginLeft: "0.5rem" }}
                          variant="body2"
                        >
                          Samtycke saknas
                        </Typography>
                      );
                    }
                    return consentText;
                  })()}
                </StyledCell>
              )}
            </StyledRow>
          ))}
          <StyledRow>
            <StyledCell>{t("searchCard.cardInfo.period")}</StyledCell>
            <StyledCell>
              <Typography></Typography>
              {currentCard.startDate.toLocaleDateString("sv")}
              &nbsp;&nbsp;-&nbsp;&nbsp;
              {currentCard.endDate
                ? currentCard.endDate.toLocaleDateString("sv")
                : ""}
            </StyledCell>
          </StyledRow>
          {currentCard.preliminaryCardDate ? (
            <StyledRow>
              <StyledCell>{t("preliminaryCardDate")}</StyledCell>
              <StyledCell>
                <Typography></Typography>
                {currentCard.preliminaryCardDate.toLocaleDateString("sv")}
              </StyledCell>
            </StyledRow>
          ) : null}
          <StyledRow>
            <StyledCell>{t("searchCard.cardInfo.registerdTxns")}</StyledCell>
            <StyledCell>{currentCard.currentAmount + " kr"}</StyledCell>
          </StyledRow>
          {(currentCard.status === "BELOW_LIMIT" || currentCard.amountToLimit < 0) && 
          <StyledRow>
            <StyledCell>{t("searchCard.cardInfo.amountToLimit")}</StyledCell>
            <StyledCell>{currentCard.amountToLimit + " kr"}</StyledCell>
          </StyledRow>}
          <StyledRow>
            <StyledCell>{t("searchCard.cardInfo.cardType")}</StyledCell>
            <StyledCell>{currentCard.cardType.name}</StyledCell>
          </StyledRow>
          <StyledRow>
            <StyledCell>{t("searchCard.cardInfo.cardId")}</StyledCell>
            <StyledCell>{currentCard.cardId}</StyledCell>
          </StyledRow>
          {consent.readConsent ? (
            <StyledRow>
              <StyledCell>{t("searchCard.cardInfo.carePrincipal")}</StyledCell>
              <StyledCell>{currentCard.carePrincipal.id}</StyledCell>
            </StyledRow>
          ) : null}
        </TableBody>
      </Table>
      <Divider sx={{ marginTop: "2rem", marginBottom: "2rem" }} />
    </Box>
  );
}

function getStatusImg(cardStatus: string) {
  const imgSize = "8vh";
  switch (cardStatus) {
    case "BELOW_LIMIT":
      return (
        <CancelIcon
          sx={{ width: imgSize, height: imgSize, color: "#be0000" }}
        />
      );
    case "BELOWLIMIT":
      return (
        <CancelIcon
          sx={{ width: imgSize, height: imgSize, color: "#be0000" }}
        />
      );
    case "FINAL":
      return (
        <CheckCircleIcon
          sx={{ width: imgSize, height: imgSize, color: "green" }}
        />
      );
    case "PRELIMINARY":
      return (
        <HelpIcon sx={{ width: imgSize, height: imgSize, color: "#FFBF00" }} />
      );
    case "EXPIRED":
      return (
        <InfoIcon sx={{ width: "4vh", height: "4vh", color: "#3399FF" }} />
      );
    default:
      return <CancelIcon />;
  }
}
